import React from 'react'
import { IIntegrationHash } from '@api/integration/types'
import { Tag, Classes } from '@blueprintjs/core'
import track from '@track'
import Event from '@track/Event'

export default function Integrations({
  availableByCategories,
  activeSection,
  setActive,
  loading = false,
}: {
  availableByCategories: IIntegrationHash
  activeSection: string
  setActive: (para: string) => void
  loading?: boolean
}) {
  let allCount = 0
  const categories = Object.keys(availableByCategories).map((key: string) => {
    allCount += availableByCategories[key].length
    return {
      name: key,
      count: availableByCategories[key].length,
    }
  })

  return (
    <div className="sticky" style={{ top: 74, width: 260, flexShrink: 0 }}>
      <Category
        isLoading={loading}
        key={'All'}
        name={loading ? 'SSSSSSSSSS' : 'All'}
        count={loading ? 0 : allCount}
        isActive={activeSection === 'All'}
        onClick={() => {
          track.integration({
            eventName: Event.TAB_CLICK,
            props: { tabName: 'All' },
          })
          setActive('All')
        }}
      />
      {categories.map(({ name, count }) => (
        <Category
          isLoading={loading}
          key={name}
          onClick={() => {
            track.integration({
              eventName: Event.TAB_CLICK,
              props: { tabName: name },
            })
            setActive(name)
          }}
          name={name}
          count={count}
          isActive={activeSection === name}
        />
      ))}
    </div>
  )
}

function Category({
  name,
  count,
  isActive,
  onClick,
  isLoading,
}: {
  name: string
  count: number
  isActive: boolean
  onClick: (id: string) => void
  isLoading?: boolean
}) {
  return (
    <div
      className={`
    flex
    justify-between
    items-center
    h-10
    text-base
    px-2
    rounded
    cursor-pointer
    ${isActive ? 'bg-primary-green' : 'hover:bg-grey-200'}
    ${isActive ? 'bg-primary-green' : 'bg-white'}
    ${isActive ? 'text-white' : 'text-grey-900'}
    ${isActive ? 'font-bold' : 'font-normal'}
    `}
      onClick={() => onClick(name)}
    >
      <div className={isLoading ? Classes.SKELETON : undefined}>{name}</div>
      <Tag
        className={isLoading ? Classes.SKELETON : undefined}
        minimal
        round
        style={{ color: isActive ? 'white' : 'black' }}
      >
        {count}
      </Tag>
    </div>
  )
}
